/* unplugin-vue-components disabled */
import {normalizeSkills, normalizeSources} from './chat-input-defs'
import ContentEditable from 'components/content-editable'
import MobileInput from './mobile-input.vue'

export default {
  components: {ContentEditable, MobileInput},
  mixins: [ModelValue(String)],
  inject: ['di_caps'],
  props: {
    placeholder: {type: String, default: 'Ask..'},
    editorDisabled: {type: Boolean, default: false},
    allowResize: {type: Boolean, default: false},
  },
  emits: ['focusin', 'focusout', 'push', 'stop', 'rows'],
  computed: {
    options(){
      let {sources = [], skills = []} = this.di_caps || {}
      skills = normalizeSkills(skills).map(skill => ({
        ...skill,
        type: 'skill'
      }))
      sources = normalizeSources(sources).map(source => ({
        ...source,
        type: 'source',
      }))

      return [...skills, ...sources]
    }
  },
  methods: {
    getContentWidth() {
      if (this.$responsive.mobile) return
      return this.$refs.input.getContentWidth()
    },
    focus(ev) {
      this.$refs.input.focus(ev)
    },
    blur() {
      this.$refs.input.blur()
    },
    setCommand(command) {
      this.$refs.input.setCommand(command)
    },
    onKeyEnter(ev){
      if (ev.shiftKey) return
      ev.preventDefault()
      this.$emit('push', ev)
    },
  }
}
